var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-selector"},[_vm._v("\n    Language: \n    "),_vm._l((_vm.languages),function(lang){return _c('router-link',{key:lang.link,class:_vm.getClass(_vm.room, lang),attrs:{"to":_vm.getUrl(_vm.room, lang),"tag":"a"}},[_vm._v("\n        "+_vm._s(lang.display)+" \n    ")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50850b87","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/langaugeselector.vue
// module id = null
// module chunks = 